<template>
    <MDBCard>
      <MDBCardHeader>
        <span class="h5"> {{ buergerbuero.name }}</span>
      </MDBCardHeader>
      <MDBCardBody>
        <p><MDBIcon icon="map-marked" iconStyle="fas" class="text-primary me-2"/>{{ buergerbuero.street }}, {{ buergerbuero.zip }} {{ buergerbuero.city }}</p>
        <div v-for="tel in buergerbuero.tel" :key="tel">
          <p><MDBIcon icon="phone" iconStyle="fas" class="text-primary me-2"/><a :title="buergerbuero.name + ' anrufen'" :href="'tel:'+tel">{{tel}}</a></p>
        </div>
        <p v-if="buergerbuero.email"><MDBIcon icon="envelope" iconStyle="fas" class="text-primary me-2"/><a :href="'mailto:'+buergerbuero.email" :title="'E-Mail an '+ buergerbuero.name + ' schreiben'" >{{buergerbuero.email}}</a></p>
        <p v-if="buergerbuero.url"><MDBIcon icon="globe" iconStyle="fas" class="text-primary me-2"/><a :href="buergerbuero.url" :title="'Webseite von '+ buergerbuero.name">Webseite von {{buergerbuero.name}} besuchen</a></p>
        <p v-if="buergerbuero.description">{{buergerbuero.description}}</p>
        <h5 v-if="buergerbuero.opening_hours.length > 0">Öffnungszeiten von {{ buergerbuero.name }}</h5>
        <table>
          <tr v-for="opening_hours in buergerbuero.opening_hours" :key="opening_hours">
            <td class="px-4 align-top">
              <p><strong>{{opening_hours.day}}</strong> </p>
            </td>
            <td class="align-top">
              <div v-for="opening_hours2 in opening_hours.opening_hours" :key="opening_hours2">
                <p>{{ opening_hours2.from }} - {{ opening_hours2.till }}</p>
              </div>
            </td>
          </tr>
        </table>
      </MDBCardBody>
    </MDBCard>
</template>
<script>
import { MDBCard, MDBCardBody, MDBCardHeader, MDBIcon  } from "mdb-vue-ui-kit"

export default {
  name: 'Buergerbuero',
  props: {
    buergerbuero: null
  },
  components: {
    MDBCard,
    MDBCardBody,
    MDBCardHeader,
    MDBIcon
  },
  data() {
    return {

    };
  }
}
</script>
